<script setup lang="ts">
import { useGoogleStore } from "../store/google";
import type { BlokGoogleReviews } from "@/.storyblok/types/120421/storyblok-components";

defineProps<{
  blok: BlokGoogleReviews;
}>();

const { locale } = useI18n();
const googleStore = useGoogleStore();

watch(
  () => locale.value,
  async () => {
    await googleStore.fetchReviews();
  }
);

if (!googleStore.reviews) {
  await googleStore.fetchReviews();
}
</script>

<template>
  <BaseContentSection v-if="googleStore.reviews?.length" v-editable="blok" background-color="light" class="text-center">
    <div class="mb-2">
      {{ googleStore.rating }} {{ blok.starsDescription }}
    </div>
    <BaseRating
      class="mb-2 text-3xl"
      :rating="googleStore.rating"
    ></BaseRating>
    <BaseHeadlineAndText
      :headline="blok.headline"
      :text="blok.description"
      class="mb-10"
    ></BaseHeadlineAndText>

    <template v-for="review of googleStore?.reviews" :key="review?.authorAttribution?.displayName">
      <BaseNote
      v-if="review?.rating && review?.rating >= 4"
        class="xs:max-w-screen-xs sm:max-w-screen-sm mx-auto mb-6"
      >
      <figure v-if="review?.text?.text">
        <figcaption  class="mb-2">
          <strong>{{ review?.authorAttribution?.displayName }}</strong> <BaseRating class="inline-block text-lg" :rating="review?.rating"></BaseRating>
        </figcaption>
        <blockquote class="mb-4 italic">"{{ review?.text?.text }}"</blockquote>
      </figure>
      </BaseNote>
    </template>

    <BauernhofUrlaubWidget />
  </BaseContentSection>
</template>